import { Route, Routes } from 'react-router-dom';
import { useState } from 'react';

import { DashboardRoutes } from './routes/DashboardRoutes';
import { ProductRoutes } from './routes/ProductRoutes';
import { PageRoutes } from './routes/PageRoutes';
import { BlogRoutes } from './routes/BlogRoutes';
import { OrderRoutes } from './routes/OrderRoutes';
import { CustomerRoutes } from './routes/CustomerRoutes';
import { SubscriberRoutes } from './routes/SubscriberRoutes';
import { TeamRoutes } from './routes/TeamRoutes';
import { AppearanceRoutes } from './routes/AppearanceRoutes';
import { CouponRoute } from './routes/CouponRoute';
import { SettingRoutes } from './routes/SettingRoutes';
import { MediaRoutes } from './routes/MediaRoutes';
import { AuthRoutes } from './routes/AuthRoute';
import { MobileMenuRoutes } from './routes/MobileMenuRoutes';

import './App.css';
import { hasPermission } from './utils/functions';
import ErrorPage from './components/ErrorPage';

function App() {
    const [menuActive, setMenuActive] = useState(false);
    return (
        <>
            <Routes>
                {hasPermission('dashboard') &&
                    DashboardRoutes({ menuActive, setMenuActive })
                }
                {hasPermission('products') &&
                    ProductRoutes({ menuActive, setMenuActive })}
                {hasPermission('pages') &&
                    PageRoutes({ menuActive, setMenuActive })}
                {hasPermission('blog') &&
                    BlogRoutes({ menuActive, setMenuActive })}
                {hasPermission('orders') &&
                    OrderRoutes({ menuActive, setMenuActive })
                }
                {hasPermission('customers') &&
                    CustomerRoutes({ menuActive, setMenuActive })
                }
                {hasPermission('subscribers') &&
                    SubscriberRoutes({ menuActive, setMenuActive })
                }
                {hasPermission('team') &&
                    TeamRoutes({ menuActive, setMenuActive })
                }
                {hasPermission('appearance') &&
                    AppearanceRoutes({ menuActive, setMenuActive })
                }
                {hasPermission('coupons') &&
                    CouponRoute({ menuActive, setMenuActive })}
                {hasPermission('media') &&
                    MediaRoutes({ menuActive, setMenuActive })}
                {hasPermission('mobileMenu') &&
                    MobileMenuRoutes({ menuActive, setMenuActive })}
                {hasPermission('settings') &&
                    SettingRoutes({ menuActive, setMenuActive })}
                {AuthRoutes({ menuActive, setMenuActive })}

                <Route path="*" element={<ErrorPage />} />
            </Routes>
        </>
    );
}

export default App;
